/* @flow */

import * as React from 'react';

import { dateFormatter } from '../utils/dateFormatter';

export type Props = {};
export type State = { time: string };

export default class extends React.PureComponent<Props, State> {
  _timer = null;

  state = { time: '' }

  componentDidMount() {
    this._timer = setInterval(() => {
      this.setState({ time: this._generate() });
    }, 500);
  }

  componentWillUnmount() {
    this._timer && clearInterval(this._timer);
  }

  _generate = () => dateFormatter(new Date());

  render() {
    return this.state.time || this._generate();
  }
}
